import COLORS from './colors';

export const typography = {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
};

export const pageContentWidth = '560px';
export const sidebarWidth = '200px';

export const appBarHeight = '64px';
export const contextBarHeight = '48px';

export const spacing = {
  xxxSmall: '2px',
  xxSmall: '4px',
  xSmall: '8px',
  small: '12px',
  medium: '16px',
  xLarge: '24px',
  xxLarge: '32px',
  xxxGiant: '56px',
  xLargeGiant: '88px',
};

export const transition = {
  color: 'color 250ms ease',
};

export const pageContentWithSidebarWidth = `calc(${pageContentWidth} + ${spacing.xLarge} + ${sidebarWidth})`;

export const smallWidth = 600;
export const mobileSpacing = 8;
export const desktopSpacing = 48;

export const breakpoints = {
  small: `${smallWidth}px`,
  mediumStart: `${smallWidth + 1}px`,
};

const AulaTheme = {
  typography,
  palette: {
    primary: {
      main: COLORS.green,
      contrastText: COLORS.default,
    },
    secondary: {
      main: COLORS.purple,
      contrastText: COLORS.default,
    },
  },
};

export default AulaTheme;
